// extracted by mini-css-extract-plugin
module.exports =  {"itemName":"itemName__3CaZh"};